export default __webpack_public_path__ + "static/media/coilsoftheserpent.0035d8cd.png";